<div
  class="flex flex-column gap-spacing-3xl background-surface-base-invert-bg main-details"
>
  <div class="flex justify-content-between align-items-center">
    <div class="title-medium-bold color-text-black-color">Details</div>
    <div
      class="date-badge color-background-grey-light-bg pl-spacing-xs pr-spacing-xs"
    >
      <div class="body-medium-medium">
        {{
          rideDetailsResult
            ? this.datepipe.transform(
                rideDetailsResult.dateOfService,
                "MMM dd, yyyy"
              )
            : ("" | date: "MMM dd, yyyy")
        }}
      </div>
    </div>
  </div>

  <div class="info-section flex flex-column gap-spacing-xs">
    <div class="section-header body-medium-medium color-text-black-color">
      Ride Details
    </div>

    <div
      class="section-table flex flex-column gap-spacing-xl background-muted-secondary-bg p-spacing-xl"
    >
      <div class="flex gap-spacing-md align-items-center">
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="driver-name"
            src="assets/icons/drive-name.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              DRIVER NAME
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.fullName : "" }}
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="vehicle-type"
            src="assets/icons/driver-id.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              DRIVER ID
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.driverId : "" }}
            </div>
          </div>
        </div>
        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="ride-id"
            src="assets/icons/ride-id.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              RIDE ID
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.rideId : "" }}
            </div>
          </div>
        </div>
      </div>

      <div class="border-left-1 splitter"></div>

      <div class="flex gap-spacing-md align-items-center">
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="ride-status"
            src="assets/icons/ride-status.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              RIDE STATUS
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.lookupName : "" }}
            </div>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="distance"
            src="assets/icons/distance.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              DISTANCE
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.distance : "" }}
            </div>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="duration"
            src="assets/icons/duration.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              DURATION
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.duration : "" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section flex flex-column gap-spacing-xs">
    <div class="section-header body-medium-medium color-text-black-color">
      Ride Events
    </div>

    <div
      class="section-table flex flex-column gap-spacing-xl background-muted-secondary-bg p-spacing-xl"
    >
      <div class="flex gap-spacing-md align-items-center">
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="phone-used"
            src="assets/icons/phone-useg.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              PHONE USAGE
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ getRideEventValue(1) }}%
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="hard-braking"
            src="assets/icons/hard-breaking.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              HARD BRAKING
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ getRideEventValue(4) }}%
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="hard-return"
            src="assets/icons/hard-return.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              HARD RETURNS
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ getRideEventValue(5) }}%
            </div>
          </div>
        </div>
      </div>

      <div class="border-left-1 splitter"></div>

      <div class="flex gap-spacing-md align-items-center">
        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="speed-limit"
            src="assets/icons/speed.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">SPEED</div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ getRideEventValue(3) }}%
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="acceleration"
            src="assets/icons/acceleration.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              ACCELERATION
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ getRideEventValue(2) }}%
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="flex gap-spacing-xs align-items-center flex-1">
          <img
            alt="percentage"
            src="assets/icons/percentage.svg"
            class="info-icon"
          />
          <div class="information">
            <div class="title label-medium-regular text-light-color">
              PERCENTAGE
            </div>
            <div
              class="value body-medium-medium background-fill-secondary-color"
            >
              {{ rideDetailsResult ? rideDetailsResult.percentage : "" }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section flex flex-column gap-spacing-xs">
    <div class="section-header body-medium-medium color-text-black-color">
      Driver Statistics
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="table-view-grid">
          <div class="table-view-row">
            <div class="table-view-cell">TOTAL RIDES</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalRide
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">DISTANCE</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalDistance
                  : ""
              }}
              mi
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">DURATION</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? splitTime(rideDetailsResult.driverStatistic.totalDuration)
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">PHONE USAGE</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalPhoneUsed
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">HARD BRAKING</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalHardBraking
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">HARD RETURN</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalHardReturn
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">SPEED</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalSpeed
                  : ""
              }}
            </div>
          </div>
          <div class="table-view-row">
            <div class="table-view-cell">ACCELERATION</div>
            <div class="table-view-cell">
              {{
                rideDetailsResult && rideDetailsResult.driverStatistic
                  ? rideDetailsResult.driverStatistic.totalAcceleration
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
